import { render, staticRenderFns } from "./ReportSingle.vue?vue&type=template&id=c0977b46&"
import script from "./ReportSingle.vue?vue&type=script&lang=js&"
export * from "./ReportSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports